<script lang="ts" setup>
import { useAuth } from '@shared/logto/vue';
import { useRoute, useRouter } from 'vue-router';

const props = defineProps<{
  notFound?: boolean;
}>();

const { logout, user } = useAuth();

const router = useRouter();
const route = useRoute();

function retry() {
  if (props.notFound) {
    router.back();
    return;
  }
  window.location.replace((route.query.returnTo as string) || '/');
}
</script>

<template>
  <div
    mx-auto
    max-w-600px
  >
    <n-alert
      type="error"
      title="Error"
      m-4
    >
      <template v-if="notFound">
        Page not found
      </template>
      <template v-else-if="route.query.message">
        {{ route.query.message }}
      </template>
      <template v-else>
        Something go wrong, please retry later
      </template>
      <br>
      <n-button
        secondary
        my-2
        @click="retry"
      >
        Retry
      </n-button>
      <n-button
        v-if="user.id"
        secondary
        my-2
        ml-2
        @click="logout"
      >
        Logout
      </n-button>
    </n-alert>
  </div>
</template>
